<p-toast></p-toast>

<form [formGroup]="voucherForm" (ngSubmit)="save()" class="p-fluid surface-section p-4 border-round-lg">
  <div class="form-group mb-4">
    <p-floatLabel>
      <p-dropdown [options]="(voucherTypeOptions$ | async) || []" formControlName="voucherType" optionLabel="label"
        optionValue="value" placeholder="Dokumententyp wählen" [showClear]="true">
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <div class="flex align-items-center" *ngIf="selectedOption">
            <i [class]="selectedOption.icon" [style.color]="selectedOption.color" class="mr-2"></i>
            <span>{{ selectedOption.label }}</span>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="flex align-items-center">
            <i [class]="item.icon" [style.color]="item.color" class="mr-2 text-xl"></i>
            <span class="ml-2">{{ item.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
      <label>Dokumententyp</label>
    </p-floatLabel>
    <small *ngIf="isInvalid('voucherType')" class="p-error">Dokumententyp erforderlich</small>
  </div>
  <div class="form-group mb-4">
    <p-floatLabel>
      <input pInputText formControlName="titel" />
      <label>Titel</label>
    </p-floatLabel>
  </div>
  <div class="form-group mb-4" *ngIf="!selectedUser">
    <p-floatLabel>
      <p-dropdown [options]="users" optionLabel="fullName" optionValue="userId" formControlName="userId" appendTo="body"
        [showClear]="true" [filter]="true" filterPlaceholder="Namen suchen" [filterMatchMode]="'contains'"
        class="custom-dropdown">
      </p-dropdown>
      <label>Interessent und Teilnehmer</label>
    </p-floatLabel>
    <small *ngIf="isInvalid('userId')" class="p-error">Benutzer erforderlich</small>
  </div>
  <div class="form-group mb-4">
    <label class="block mb-2 text-500">Zusatzinformationen</label>
    <p-editor formControlName="freitext" [style]="{height:'200px'}"></p-editor>
  </div>
  <div class="form-group">
    <app-filedrop #drop bucketname="ihk-bildungsgutschein" [oldFiles]="oldFiles"
      (fileUploadStarted)="uploadInProgress = true" (fileUploadCompleted)="onFilesUploaded($event)">
    </app-filedrop>
    <small class="block mt-2 mb-4 text-500">* Pflichtfelder (Dokumententyp, Benutzer & Datei)</small>
  </div>
  <div class="form-buttons flex gap-2">
    <button pButton type="submit" label="Speichern" icon="pi pi-save" class="p-button-success"
      [disabled]="voucherForm.invalid || uploadInProgress || saving || (!hasFiles() && oldFiles.length === 0)">
    </button>

    <button pButton type="button" label="Abbrechen" icon="pi pi-times" class="p-button-secondary"
      (click)="closeDialog()">
    </button>
  </div>
</form>